import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    datosConCodigoPostal: [],
    listaPaises: []
  },
  mutations: {

    getDatosConCodigoPostal(state, datos) {
      state.datosConCodigoPostal = datos;
    },
    getListaPaises(state, datos) {
      state.listaPaises = datos;
    },
    destroySepomex(state) {
      state.datosConCodigoPostal = [];
    },

  },
  actions: {
    async destroySepomex({ commit }) {
      commit('destroySepomex');
    },
    async getDatosConCodigoPostal({
      commit,
    }, cod) {
      try {
        const res = await api.getDatosConCodigoPostal(cod);
        // console.log(object);
        if (res.data.DATOS) {
          // console.log('datitos',res.data.DATOS);
          //   commit('getDatosConCodigoPostal', res.data.DATOS);
          return [true, res.data.DATOS];
        } return [false, 'blah'];
      } catch (error) {
        console.log(error);
      }
    },

    async getListaPaises({
      commit,
    },) {
      try {
        const res = await api.getListaPaises();
        // console.log(object);
        if (res.data.DATOS) {
          // console.log('datitos',res.data.DATOS);
          commit('getListaPaises', res.data.DATOS);
          return [true, res.data.DATOS];
        } return [false, 'blah'];
      } catch (error) {
        console.log(error);
      }
    },

  },
};
